import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

export const getUserMenuEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SECURITY}/getmenu`,
  });
};

export const getUserMenuItemsEffect = (NavigationID) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      NavigationID,
    },
    url: `${API.SECURITY}/getmenuitems`,
  });
};

export const getCompanyListEffect = () => {
  return axiosInstance.get(`${API.PRIMARY}/user/$companylist`, {});
};

export const getUserTypesEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SECURITY}/GetAllUserTypes`,
  });
};

export const getUserProfileEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SECURITY}/GetUserProfile`,
  });
};

let updateUserPreferenceEffectCancelToken = () => {};
export const updateUserPreferenceEffect = (data) => {
  updateUserPreferenceEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      updateUserPreferenceEffectCancelToken = c;
    }),
    data,
    method: 'post',
    url: `${API.SECURITY}/SaveUserPreference`,
  });
};

export const getUserPreferenceEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SECURITY}/GetUserPreference`,
  });
};

export const approveRejectShipmentEffects = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/ActionNeededProcess`,
  });
};

export const getReportApplicationLinkEffect = (NavigationID) => {
  return axiosInstance.request({
    method: 'get',
    params: { NavigationID },
    url: `${API.SECURITY}/GetReportApplicationLink`,
  });
};
